/**
 * Modern thin-stroke icons for the sidebar (24x24 viewBox).
 * Inspired by wati.io / respond.io — clean, minimal, 1.5px stroke weight.
 * All paths are optimized Lucide-style with rounded joins.
 */
export const SIDEBAR_ICONS: Record<string, string[]> = {
  smartphone: ["M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z", "M10 5h4", "M11.5 18h1"],
  menu: ["M4 6h16", "M4 12h16", "M4 18h16"],
  globe: ["M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20", "M2 12h20", "M12 2a18 18 0 0 1 0 20 18 18 0 0 1 0-20"],
  // ── Rail section icons ──────────────────────────────────────────────

  "layout-dashboard": [
    "M3 3h7v9H3z",
    "M14 3h7v5h-7z",
    "M14 12h7v9h-7z",
    "M3 16h7v5H3z",
  ],
  inbox: [
    "M22 12h-6l-2 3H10l-2-3H2",
    "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
  ],
  onboarding: [
    "M12 2 2 7l10 5 10-5-10-5z",
    "M2 17l10 5 10-5",
    "M2 12l10 5 10-5",
  ],
  megaphone: [
    "m3 11 18-5v12L3 13v-2z",
    "M11.6 16.8a3 3 0 1 1-5.8-1.6",
  ],
  workflow: [
    "M7 12h4",
    "M11 12V8",
    "M11 12v4",
    "M11 8h6",
    "M11 16h6",
    "M5 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    "M19 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    "M19 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  ],
  "reports-rail": [
    "M3 3v18h18",
    "M7 16l4-8 4 5 5-9",
  ],
  settings: [
    "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  ],
  "book-open": [
    "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z",
    "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z",
  ],
  store: [
    "M2 7l1.41-3.53A2 2 0 0 1 5.26 2h13.48a2 2 0 0 1 1.86 1.27L22 7",
    "M3.04 7a2.1 2.1 0 0 0 .58 3.53A2.17 2.17 0 0 0 6 10a2 2 0 0 0 3 1 2 2 0 0 0 3-1 2 2 0 0 0 3 1 2 2 0 0 0 3-1 2.17 2.17 0 0 0 2.38.53A2.1 2.1 0 0 0 20.96 7",
    "M4 10v12h16V10",
    "M15 22v-7a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v7",
  ],
  server: [
    "M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z",
    "M2 15a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z",
    "M6 7h.01",
    "M6 17h.01",
  ],

  // ── Common menu item icons ──────────────────────────────────────────

  "address-book": [
    "M4 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4",
    "M10 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    "M14 16c0-2-2-3-4-3s-4 1-4 3",
    "M20 6h-2",
    "M20 12h-2",
    "M20 18h-2",
  ],
  clipboard: [
    "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
    "M15 2H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z",
  ],
  sparkles: [
    "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.582a.5.5 0 0 1 0 .962L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.962 0z",
    "M20 3v4",
    "M22 5h-4",
  ],
  bolt: ["M13 2 3 14h9l-1 8 10-12h-9l1-8z"],
  plus: ["M5 12h14", "M12 5v14"],
  history: [
    "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
    "M3 3v5h5",
    "M12 7v5l4 2",
  ],
  calendar: [
    "M8 2v4",
    "M16 2v4",
    "M3 10h18",
    "M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z",
  ],
  reply: [
    "M9 17H4a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h5",
    "m13 7 5 5-5 5V7z",
  ],
  bot: [
    "M12 8V4H8",
    "M4 12a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v4a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z",
    "M9 14h.01",
    "M15 14h.01",
    "M12 2v2",
  ],
  shapes: [
    "m13.73 4-2-3.46a2 2 0 0 0-3.48 0l-2 3.46A2 2 0 0 0 8 8h4a2 2 0 0 0 1.73-4z",
    "M14 14h6a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2z",
    "M7 17.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
  ],
  bell: [
    "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9",
    "M10.3 21a1.94 1.94 0 0 0 3.4 0",
  ],
  "shopping-cart": [
    "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6",
    "M9 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    "M20 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
  ],
  package: [
    "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
    "M12 22V12",
    "m3.3 7 7.7 4 7.7-4",
    "M7.5 4.27 12 6.73l4.5-2.46",
  ],
  receipt: [
    "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
    "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8",
    "M12 17.5v-11",
  ],
  "credit-card": [
    "M21 4H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z",
    "M1 10h22",
    "M6 14h2",
    "M12 14h2",
  ],
  truck: [
    "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2",
    "M15 18H9",
    "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
    "M7 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    "M20 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  ],
  "calendar-check": [
    "M8 2v4",
    "M16 2v4",
    "M3 10h18",
    "M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z",
    "m9 16 2 2 4-4",
  ],
  ticket: [
    "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z",
    "M13 5v2",
    "M13 17v2",
    "M13 11v2",
  ],
  sliders: [
    "M4 21v-7",
    "M4 10V3",
    "M12 21v-9",
    "M12 8V3",
    "M20 21v-5",
    "M20 12V3",
    "M2 14h4",
    "M10 8h4",
    "M18 16h4",
  ],
  meta: [
    "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Z",
    "M12 12c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z",
  ],
  users: [
    "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
    "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    "M22 21v-2a4 4 0 0 0-3-3.87",
    "M16 3.13a4 4 0 0 1 0 7.75",
  ],
  user: [
    "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2",
    "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  ],
  newspaper: [
    "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2",
    "M10 6h8",
    "M10 10h8",
    "M10 14h4",
  ],
  tags: [
    "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
    "M7.5 7.5h.01",
  ],
  folder: [
    "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
  ],
  coins: [
    "M12 22a7 7 0 1 0 0-14 7 7 0 0 0 0 14z",
    "M12 12v3",
    "M10.5 16.5h3",
    "M15 2.2c3 .9 5.4 3.3 6.3 6.3",
    "M19.8 15c-.9 3-3.3 5.4-6.3 6.3",
  ],
  building: [
    "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18",
    "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2",
    "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
    "M10 6h4",
    "M10 10h4",
    "M10 14h4",
    "M10 18h4",
  ],
  "map-pin": [
    "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z",
    "M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  ],
  palette: [
    "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z",
    "M12 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    "M7.5 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    "M10.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    "M15.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    "M16.5 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
  ],
  whatsapp: [
    "M7.9 20A9 9 0 1 0 4 16.1L2 22Z",
    "M9.5 9.5c.5-1 1.5-1 2 0l.8 1.2c.3.4.2 1-.2 1.3l-.6.5a6 6 0 0 0 2.7 2.7l.5-.6c.3-.4.9-.5 1.3-.2l1.2.8c1 .5 1 1.5 0 2l-.4.3c-.8.5-1.8.4-2.7 0A9.5 9.5 0 0 1 9 11.9c-.4-.9-.5-1.9 0-2.7z",
  ],
  mail: [
    "M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z",
    "m22 6-10 7L2 6",
  ],
  messages: [
    "M7.9 20A9 9 0 1 0 4 16.1L2 22z",
  ],
  send: [
    "m22 2-7 20-4-9-9-4Z",
    "M22 2 11 13",
  ],
  phone: [
    "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z",
  ],
  "play-circle": ["M12 2a10 10 0 1 0 0 20a10 10 0 1 0 0-20z", "m10 8 6 4-6 4z"],
  activity: ["M22 12h-4l-3 9L9 3l-3 9H2"],
  "bar-chart": [
    "M12 20V10",
    "M18 20V4",
    "M6 20v-4",
  ],
  layers: [
    "M12 2 2 7l10 5 10-5-10-5z",
    "M2 17l10 5 10-5",
    "M2 12l10 5 10-5",
  ],
  "circle-play": [
    "M10 9l5 3-5 3z",
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
  ],
  "log-out": [
    "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
    "M16 17l5-5-5-5",
    "M21 12H9",
  ],
  circle: ["M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"],
  brain: [
    "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
    "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
    "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4",
    "M12 5v13",
  ],
  "user-cog": [
    "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
    "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    "M19.5 12.6l.7.7a1.7 1.7 0 0 1 0 2.4l-.7.7",
    "M21.1 15a1.7 1.7 0 0 1 0 2l-1 .6",
    "M19 19a2 2 0 1 1-2.7-2.7",
  ],
  clock: [
    "M12 6v6l4 2",
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
  ],
  "share-2": [
    "M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    "M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    "M18 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    "M8.59 13.51l6.83 3.98",
    "M15.41 6.51l-6.82 3.98",
  ],
  "message-reply": [
    "M7.9 20A9 9 0 1 0 4 16.1L2 22z",
    "m10 9-3 3 3 3",
    "M7 12h7",
  ],
  upload: [
    "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
    "M17 8l-5-5-5 5",
    "M12 3v12",
  ],
  barcode: [
    "M3 5v-2h4",
    "M3 19v2h4",
    "M17 5V3h4v2",
    "M17 21v-2h4v2",
    "M7 8v8",
    "M12 8v8",
    "M17 8v8",
  ],
  "qr-code": [
    "M4 3h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z",
    "M17 3h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z",
    "M4 16h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1z",
    "M21 16h-3a2 2 0 0 0-2 2v3",
    "M21 21v.01",
    "M12 7v3a2 2 0 0 1-2 2H7",
    "M3 12h.01",
    "M12 3h.01",
    "M12 16v.01",
    "M16 12h1",
    "M21 12v.01",
    "M12 21v-1",
  ],
  bed: [
    "M2 4v16",
    "M2 8h18a2 2 0 0 1 2 2v10",
    "M2 17h20",
    "M6 8v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2",
    "M6 12a2 2 0 1 1 4 0",
  ],
  book: [
    "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
  ],
  link: [
    "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71",
    "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71",
  ],
  list: [
    "M8 6h13",
    "M8 12h13",
    "M8 18h13",
    "M3 6h.01",
    "M3 12h.01",
    "M3 18h.01",
  ],
  "list-check": [
    "M11 18H3",
    "M16 6H3",
    "M16 12H3",
    "m16 12 2 2 4-4",
    "m16 18 2 2 4-4",
  ],
  info: [
    "M12 16v-4",
    "M12 8h.01",
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
  ],
  "file-text": [
    "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z",
    "M14 2v6h6",
    "M16 13H8",
    "M16 17H8",
    "M10 9H8",
  ],
  pen: [
    "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z",
    "m15 5 4 4",
  ],
  "trash-2": [
    "M3 6h18",
    "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
    "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
    "M10 11v6",
    "M14 11v6",
  ],
  x: ["M18 6 6 18", "M6 6l12 12"],
  "grip-vertical": [
    "M9 5h.01",
    "M9 12h.01",
    "M9 19h.01",
    "M15 5h.01",
    "M15 12h.01",
    "M15 19h.01",
  ],
  "more-vertical": [
    "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    "M12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    "M12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  ],
  "chevron-down": ["m6 9 6 6 6-6"],
  "chevron-right": ["m9 18 6-6-6-6"],
  "chevron-left": ["m15 18-6-6 6-6"],
  save: [
    "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z",
    "M17 21v-8H7v8",
    "M7 3v5h8",
  ],
  type: ["M4 7V4h16v3", "M9 20h6", "M12 4v16"],
  image: [
    "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
    "M10 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
  ],
  images: [
    "M18 22H4a2 2 0 0 1-2-2V6",
    "M22 14V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z",
    "m22 14-4.09-4.09a2 2 0 0 0-2.82 0L8 19",
    "M11 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
  ],
  camera: [
    "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
    "M12 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  ],
  file: [
    "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z",
    "M14 2v6h6",
  ],
  keyboard: [
    "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z",
    "M6 10h.01",
    "M10 10h.01",
    "M14 10h.01",
    "M18 10h.01",
    "M8 14h.01",
    "M12 14h.01",
    "M16 14h.01",
    "M7 18h10",
  ],
  "align-left": ["M17 12H3", "M21 6H3", "M21 18H3", "M13 12h-2"],
  "circle-dot": [
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
    "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
  ],
  "square-check": [
    "M9 11l3 3L22 4",
    "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
  ],
  "toggle-right": [
    "M16 8a4 4 0 1 0 0 8",
    "M8 8a4 4 0 1 0 0 8",
    "M16 16H8a4 4 0 0 1 0-8h8a4 4 0 0 1 0 8z",
  ],
  heading: ["M6 12h12", "M6 4v16", "M18 4v16"],
  hash: [
    "M4 9h16",
    "M4 15h16",
    "M10 3 8 21",
    "M16 3l-2 18",
  ],
  rocket: [
    "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
    "M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
    "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0",
    "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5",
  ],
  "pie-chart": [
    "M21.21 15.89A10 10 0 1 1 8 2.83",
    "M22 12A10 10 0 0 0 12 2v10z",
  ],
  "life-buoy": [
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
    "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    "M4.93 4.93l4.24 4.24",
    "M14.83 14.83l4.24 4.24",
    "M14.83 9.17l4.24-4.24",
    "M4.93 19.07l4.24-4.24",
  ],

  // ── Dialog / form / upload glyphs (added for popup redesign) ──────────
  "folder-plus": [
    "M20 20a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
    "M12 11v6",
    "M9 14h6",
  ],
  "check-check": [
    "M18 6 7 17l-5-5",
    "m22 10-7.5 7.5L13 16",
  ],
  "log-in": [
    "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4",
    "M10 17l5-5-5-5",
    "M15 12H3",
  ],
  eye: [
    "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z",
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  ],
  download: [
    "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
    "M7 10l5 5 5-5",
    "M12 15V3",
  ],
  search: [
    "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
    "M21 21l-4.35-4.35",
  ],
  "alert-triangle": [
    "M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z",
    "M12 9v4",
    "M12 17h.01",
  ],
  "check-circle": [
    "M22 11.08V12a10 10 0 1 1-5.93-9.14",
    "M22 4 12 14.01l-3-3",
  ],
  "x-circle": [
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
    "M15 9l-6 6",
    "M9 9l6 6",
  ],
  "alert-circle": [
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
    "M12 8v4",
    "M12 16h.01",
  ],
  loader: [
    "M12 2v4",
    "M12 18v4",
    "M4.93 4.93l2.83 2.83",
    "M16.24 16.24l2.83 2.83",
    "M2 12h4",
    "M18 12h4",
    "M4.93 19.07l2.83-2.83",
    "M16.24 7.76l2.83-2.83",
  ],
  "zoom-in": [
    "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
    "M21 21l-4.35-4.35",
    "M11 8v6",
    "M8 11h6",
  ],
  "zoom-out": [
    "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
    "M21 21l-4.35-4.35",
    "M8 11h6",
  ],
  "square-x": [
    "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
    "M9 9l6 6",
    "M15 9l-6 6",
  ],
  "cloud-upload": [
    "M4 14.9A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.24",
    "M12 12v9",
    "M8 16l4-4 4 4",
  ],
  "arrow-up": ["M12 19V5", "M5 12l7-7 7 7"],
  "arrow-down": ["M12 5v14", "M19 12l-7 7-7-7"],
  "arrow-right": ["M5 12h14", "M12 5l7 7-7 7"],
  minus: ["M5 12h14"],
  check: ["M20 6 9 17l-5-5"],
  "chevron-up": ["M18 15l-6-6-6 6"],
  "chevrons-up-down": ["M7 15l5 5 5-5", "M7 9l5-5 5 5"],
  "refresh-cw": [
    "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
    "M21 3v5h-5",
    "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
    "M8 16H3v5",
  ],
};

/** Maps legacy Font Awesome class strings to SVG icon keys. */
export const FA_ICON_MAP: Record<string, string> = {
  "fa-solid fa-house": "layout-dashboard",
  "fa-solid fa-comment-dots": "inbox",
  "fa-solid fa-inbox": "inbox",
  "fa-solid fa-address-book": "address-book",
  "fa-solid fa-clipboard": "clipboard",
  "fa-solid fa-bolt": "bolt",
  "fa-solid fa-bullhorn": "megaphone",
  "fa-solid fa-plus": "plus",
  "fa-solid fa-clock-rotate-left": "history",
  "fa-regular fa-calendar-days": "calendar",
  "fa-solid fa-reply": "reply",
  "fa-solid fa-diagram-project": "workflow",
  "fa-solid fa-robot": "bot",
  "fa-solid fa-icons": "shapes",
  "fa-solid fa-bell": "bell",
  "fa-solid fa-store": "store",
  "fa-solid fa-cart-shopping": "shopping-cart",
  "fa-solid fa-box": "package",
  "fa-solid fa-receipt": "receipt",
  "fa-solid fa-credit-card": "credit-card",
  "fa-solid fa-truck": "truck",
  "fa-solid fa-calendar-check": "calendar-check",
  "fa-solid fa-life-ring": "life-buoy",
  "fa-solid fa-ticket": "ticket",
  "fa-solid fa-gear": "settings",
  "fa-solid fa-sliders": "sliders",
  "fa-brands fa-meta": "meta",
  "fa-solid fa-users": "users",
  "fa-solid fa-user": "user",
  "fa-solid fa-newspaper": "newspaper",
  "fa-solid fa-tags": "tags",
  "fa-solid fa-folder": "folder",
  "fa-solid fa-coins": "coins",
  "fa-solid fa-server": "server",
  "fa-solid fa-building": "building",
  "fa-solid fa-comments": "messages",
  "fa-solid fa-phone": "phone",
  "fa-solid fa-chart-simple": "bar-chart",
  "fa-solid fa-layer-group": "layers",
  "fa-solid fa-circle-play": "circle-play",
  "fa-solid fa-arrow-right-from-bracket": "log-out",
  "fa-solid fa-upload": "upload",
  "fa-solid fa-barcode": "barcode",
  "fa-solid fa-bed": "bed",
  "fa-solid fa-book": "book-open",
  "fa-solid fa-book-open": "book-open",
  "fa-solid fa-list-check": "list-check",
  "fa-solid fa-link": "link",
  "fa-solid fa-clock": "clock",
  "fa-solid fa-list": "list",
  "fa-solid fa-list-ul": "list",
  "fa-solid fa-info-circle": "info",
  "fa-solid fa-hashtag": "hash",
  "fa-solid fa-pager": "workflow",
  "fa-solid fa-bag-shopping": "shopping-cart",
  "fa-solid fa-dolly": "truck",
  "fas fa-store": "store",
  "fas fa-shipping-fast": "truck",
  "fas fa-box": "package",
  "fas fa-inbox": "inbox",
  "fa-regular fa-credit-card": "credit-card",
  "fa-solid fa-envelope": "reply",
  "fa-solid fa-sun": "sparkles",
  "fa-solid fa-passport": "server",
  "fa-brands fa-black-tie": "users",
  "fa-solid fa-folder-open": "folder",
  "fa-solid fa-address-card": "tags",
  "fa-solid fa-folder-blank": "folder",
  "fa-solid fa-user-tie": "users",
  "fa-brands fa-font-awesome": "building",
  "fa-brands fa-stack-exchange": "messages",
  "fa-solid fa-folder-plus": "folder-plus",
  "fa-solid fa-check-double": "check-check",
  "fa-solid fa-arrow-right-to-bracket": "log-in",
  "fa-solid fa-eye": "eye",
  "fas fa-eye": "eye",
  "fa-solid fa-download": "download",
  "fas fa-download": "download",
  "fa-solid fa-magnifying-glass": "search",
  "fa-solid fa-search": "search",
  "fa-solid fa-triangle-exclamation": "alert-triangle",
  "fa-solid fa-circle-check": "check-circle",
  "fa-solid fa-circle-xmark": "x-circle",
  "fa-solid fa-circle-exclamation": "alert-circle",
  "fas fa-circle-exclamation": "alert-circle",
  "fa-solid fa-spinner": "loader",
  "fas fa-spinner": "loader",
  "fas fa-magnifying-glass-plus": "zoom-in",
  "fas fa-magnifying-glass-minus": "zoom-out",
  "fas fa-square-check": "square-check",
  "fas fa-square-xmark": "square-x",
  "fa-solid fa-cloud-arrow-up": "cloud-upload",
  "fa-solid fa-xmark": "x",
  "fas fa-xmark": "x",
  "fa-solid fa-trash-can": "trash-2",
  "fas fa-trash-can": "trash-2",
  "fa-solid fa-pen": "pen",
  "fas fa-file-lines": "file-text",
  "fas fa-file-pdf": "file-text",
  "fas fa-file-word": "file-text",
  "fas fa-file": "file",
};

export function resolveSidebarIconKey(icon?: string): string {
  if (!icon) return "circle";
  if (SIDEBAR_ICONS[icon]) return icon;
  return FA_ICON_MAP[icon] ?? "circle";
}

export function renderSidebarIconSvg(
  icon: string,
  size = 11,
  strokeWidth = 2,
): string {
  const key = resolveSidebarIconKey(icon);
  const paths = SIDEBAR_ICONS[key] ?? SIDEBAR_ICONS["circle"];
  const pathMarkup = paths
    .map((d) => `<path d="${d}"></path>`)
    .join("");
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${pathMarkup}</svg>`;
}
